<template>
  <section
    class="py-8"
    :class="{'flex': !mobile}"
  >
    <div :class="{'w-1/2 max:pr-xl': !mobile}">
      <h3
        v-if="!isSimplify && !mobile"
        class="font-bold"
      >
        Saved Businesses
      </h3>
      <Tooltip
        v-else-if="isSimplify || mobile"
        placement="right"
        @show="analytics.click.tooltipBusinessAddresses"
      >
        <h3 class="font-bold">
          Saved Businesses
        </h3>
        <template slot="tip">
          <p
            v-if="isVerifyInfo"
            class="mb-6"
          >
            Click the link to view the Change-of-Address.
          </p>
          <p>
            The old or new address of the "Primary" business address will be used
            for billing purposes. Your credit card must match one these addresses.
            In some cases, we'll provide a third address for billing purposes.
          </p>
          <br>
          <p v-if="!isVerifyInfo">
            Click the link to edit a business name or address.
            Changes to the email, phone or phone type for the primary business address will be
            applied to all other business names and addresses.
          </p>
        </template>
      </Tooltip>
      <br>
      <div
        id="businessContainer"
        :class="{'business-alias-list': scroll && computedAddress.length >= 5}"
      >
        <div
          v-for="address in computedAddress"
          :key="address.orderUuid ? `${address.orderUuid}-${address.uuid}` : null"
        >
          <button
            :class="{'selected': selected === address.orderUuid, 'primary': address.primaryBusiness}"
            class="truncate text-blue-100 font-bold underline mt-2 business-address"
            :title="address.fullCityAddress"
            :disabled="selected === address.orderUuid"
            @click.prevent="populateSelectedAddress(address)"
          >
            {{ address.fullCityAddress }}
          </button>
          <span
            v-if="address.primaryBusiness"
            class="primary-indicator"
          >
            <p>Primary</p>
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="!isSimplify && !mobile"
      class="w-1/2"
      :class="{'business-alias-list-info': isVerifyInfo &&
        !mobile, 'pl-xl': !isVerifyInfo && !mobile}"
    >
      <p
        v-if="isVerifyInfo"
        class="mb-6"
      >
        Click the link to view the Change-of-Address.
      </p>
      <p>
        The old or new address of the "Primary" business address will be used
        for billing purposes. Your credit card must match one these addresses.
        In some cases, we'll provide a third address for billing purposes.
      </p>
      <br>
      <p v-if="!isVerifyInfo">
        Click the link to edit a business name or address.
        Changes to the email, phone or phone type for the primary business address will be
        applied to all other business names and addresses.
      </p>
    </div>
  </section>
</template>
<script>
import {
  Tooltip,
} from '@mgo/ui/lib/components';
import { desktopAnalytics } from '../../choice-views/MoveCombined/analytics';

export default {
  name: 'AddressList',
  components: {
    Tooltip,
  },
  props: {
    business: {
      type: Array,
      required: true,
      default: () => [],
    },
    busAddress: {
      type: Array,
      required: true,
      default: () => [],
    },
    scroll: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSimplify: {
      type: Boolean,
      required: true,
      default: false,
    },
    isVerifyInfo: {
      type: Boolean,
      default: false,
      required: false,
    },
    selected: {
      type: String,
      default: '',
      required: false,
    },
    mobile: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      inputPropUpdate: true,
      bus: this.business,
      addr: this.busAddress,
    };
  },
  computed: {
    analytics() {
      return desktopAnalytics();
    },
    computedAddress() {
      if (!this.business?.length) {
        return [];
      }
      return this.bus.map((businessCOA) => {
        const filteredAddress = this.addr?.filter(
          (busAddr) => busAddr.orderUuid === businessCOA.uuid,
        );
        if (!filteredAddress.length) {
          return [];
        }
        let filteredOldStreet = '';
        let filteredNewStreet = '';
        if (
          !filteredAddress
          || filteredAddress[0].addresses[0] === null
          || filteredAddress[0].addresses[1] === null
        ) {
          return [];
        }
        filteredAddress[0].addresses.forEach(({ addressType, ...addr }) => {
          if (addressType.toLowerCase() === 'old') {
            filteredOldStreet = addr.streetAddress;
          } else if (addressType.toLowerCase() === 'new') {
            filteredNewStreet = addr.streetAddress;
          }
        });
        return {
          ...businessCOA,
          orderUuid: filteredAddress[0].orderUuid,
          fullCityAddress: `${businessCOA.businessName} - ${filteredOldStreet} to ${filteredNewStreet}`,
        };
      });
    },
  },
  watch: {
    business: {
      handler(newValue) {
        this.bus = newValue;
      },
      deep: true,
    },
    busAddress: {
      handler(newValue) {
        this.addr = newValue;
      },
      deep: true,
    },
  },
  methods: {
    populateSelectedAddress(address) {
      this.$emit('address-clicked', address?.orderUuid);
    },
  },
};
</script>

<style scoped>
.business-address {
  margin:0;
  line-height: 32px;
  font-size: 14px;
}
.business-alias-list {
  max-height: 150px;
  overflow-y: scroll;
  padding-right: 17px;
}
.business-alias-list-info {
  padding-left: 70px;
}
.primary-indicator {
  @apply text-blue-200;
  display: inline-block;
  margin-left: 16px;
  font-style: italic;
  font-weight: 800;
  font-size: 14px;
  position: relative;
  right: 0px;
}
.selected {
  cursor: default;
  border-radius: 3px;
  padding-left: 8px;
  padding-right: 8px;
  text-decoration: none;
}
:focus {
  outline: none;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.truncate.primary {
  max-width: 85%;
}
@media screen and (max-width: 600px) {
  .truncate.primary {
    max-width: 75%;
  }
}
</style>
